export default {
  bondsAgreeContext: '本人确认清楚明白及同意上述有关申请开通交易债券的风险披露及声明',
  bondsTitle: '债务风险披露及声明',
  error: '请确保您已开通证券账号(现金)或证券账号(保证金)',
  successMessage: '开通成功',
  successTips: '您已成功開通債券交易權限，請前往理財頁面與我們進行預約。',
  errorMessage: {
    '5004': '获取用户邮箱模板失败，请联系客服',
    '5005': '获取用户邮箱失败，请联系客服',
    '5006': '获取用户语言失败，请联系客服',
    '5007': '获取返回数据失败，请联系客服',
    '20105': '请仔细阅读并勾选协议',
    '20101': '没有同意声明，开通失败',
    '20100': '已经开通买卖债券，无法创建',
    '20102': '账户信息不存在，开通失败',
    '20103': '交易账户信息列表不存在，开通失败',
    '20104': '请确保您已开通证券账号(现金)或证券账号(保证金)并可正常使用'
  },
  statementContext: `<div>
  <h5>以下重要资料</h5>
  <p>在继续浏览前，请先细阅重要信息，并勾选「本人确认清楚明白及同意上述债券的风险披露及声明」以确认您已理解。</p>
  <h5>独立中介人</h5>
  <p>艾德证券期货有限公司于债券销售是独立的中介人，理由如下：</p>
  <p>1. 我们没有收取由其他人士就我们向阁下分销任何债券产品而提供的费用、佣金或任何其他金钱收益；及</p>
  <p>2. 我们与债券发行人没有任何紧密联系或其他法律或经济关系，或没有从任何人士取得任何非金钱收益，而这些联系、关系或收益可能损害我们的独立性，使我们偏向任何特定债券产品、任何债券产品类别或任何债券发行人。 </p>
  <h5>产品主要风险</h5>
  <p>投资者在决定是否投资该产品前，应审慎阅读相关产品认购书（如适用）所披露的细节及风险。主要风险包括但不限于下页所载：</p>
  <p>1.流动性风险</p>
  <p>债券的流动性可能有限，及可能无活跃交易，及/或没有经纪在市场提供报价，因此：</p>
  <p>2.信贷风险</p>
  <p>投资者须承担发债机构及担保机构（如适用）的信贷风险，他们的信贷评级如有任何变动将会影响本债券的价格及价值。债券附带发债机构违责的风险，即发行机构有机会未能如期支付本金和利息。在最坏的情况下如发行人及担保人（如适用）破产，投资者可能会损失全部投资。信贷评级机构给予的信贷评级并非对发债机构信用可靠程度的保证。 </p>
  <p>(i) 不可能在任何时间均能提供债券的市值及/或参考买入/卖出价，因其将取决于市场的流动性和情况；</p>
  <p>(ii) 可能需要较长时间或无法于市场上出售债券；及</p>
  <p>(iii) 所执行的卖出价可能与本行参考买入价有很大的差别，对投资者不利。 </p>
  <p>3.利率风险</p>
  <p>债券较易受到利率波动的影响。一般来说，利率上升，债券价格便会下跌。 </p>
  <p>4.市场风险</p>
  <p>投资价值可能会因政治、法律、经济条件及利率变化而有波动。这些变化在全部市场及资产类别上都很普遍，投资者取回的投资金额有可能少于初次投放的资金。 </p>
  <p>5.外币风险</p>
  <p>以外币报价之债券，当把赎回之金额转换为本土或基本货币时，投资者有可能出现兑换损失。 </p>
  <h5>只适用于以人民币发行或挂钩资产以人民币发行之产品</h5>
  <p>人民币与外币（包括港元）的兑换须受中国的规管限制–人民币现时并非自由兑换的货币及透过香港银行兑换人民币须受若干限制。香港特区及中国内地两地的人民币与外币兑换是受中国政府规管，此举或会影响流通量。 </p>
  <h5>高息产品风险</h5>
  <p>投资于高息债券，除以上列举的一般风险外，还须承受其他风险，例如：</p>
  <p>1.较高的信贷风险</p>
  <p>高息债券的评级通常低于投资级别，或不获评级，因此涉及的发债机构违责风险往往较高</p>
  <p>2.受制于经济周期的转变</p>
  <p>经济下滑时，高息债券价值的跌幅往往会较投资级别债券为大，原因是(i)投资者会较为审慎，不愿承担风险；(ii)违责风险加剧。 </p><h5>某些债券可能别具特点及风险，投资时须格外注意。这些包括：</h5>
  <p>1.永续性债券的风险</p>
  <p>永续性债券不设到期日，其利息派付取决于发债机构在非常长远的时间内的存续能力，利息或会因根据其条款及细则而有所延迟或终止。一般而言，永续性债券一般为可赎回及/或为后偿债券，投资者须要承受再投资风险/或为后偿债券风险，详情如下。 </p>
  <p>2.可提早赎回债券的再投资风险</p>
  <p>如果这是可提早赎回的债券，当发行人在债券到期前行使赎回权利，债券持有人或面临再投资风险。发行人行使赎回权利常见于利率在债券发行后大幅回落的环境；再投资风险是指将票息收入和本金进行再投资的收益率低于购买债券时的预期收益率之风险；由于内含赎回权，可赎回债券现金流的可预测性并不明确；可赎回债券的赎回计划或有不同的赎回日，而赎回价格则视乎不同的赎回时间而定；相对不含赎回权的同类债券而言，由于债券价格受赎回价所限，可赎回债券价格的潜在升幅有限。当发债机构于债券到期前行使赎回权，投资者便会面对再投资风险。投资者于再投资时可能会收到较小的孳息率。 </p>
  <p>3.后偿债券的风险</p>
  <p>后偿债券于发债机构遣债后的清盘过程中获较低之索偿权，因此后偿债券之持有人将承受比优先债券更高的风险。后偿债券为无抵押，其信贷评级及债务的优先次序较优先债券为低。投资者应特别注意产品之信贷资料，包括发债机构，债券或担保人的信贷评级(视情况而定)。 </p>
  <p>4.浮息及／或延迟派付利息的风险</p>
  <p>如果债券具有浮息及／或延迟派付利息的条款，投资者便无法确定将收取的利息金额及利息派付的时间。 </p>
  <p>5.可延迟到期日的风险</p>
  <p>如果债券具有可延迟到期日的条款，投资者便没有一个订明偿还本金的确实时间表。 </p>
  <p>6.股票及债券的投资风险</p>
  <p>属可换股或可交换性质的债券，投资者须同时承受股票及债券的投资风险；及／或具有或然撇减或弥补亏损特点的债券。当发生触发事件时，这些债券可能会作全数或部分撇帐，或转换为普通股。 </p></div>`
}
